import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import Loader from "@/Components/Loader/Loader";
const LettersRecomdationPage = t0 => {
  const $ = _c(39);
  const {
    handelBacktoSearch,
    selectedAlphabet
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(false);
  const [, setButtonLoading] = useState(false);
  const [, setTabLoading] = useState(false);
  const [, setItemLoading] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsLoading(false);
      setButtonLoading(false);
      setTabLoading(false);
      setItemLoading(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== pathname) {
    t2 = [pathname];
    $[1] = pathname;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleRouteChangeStart = () => {
        setIsLoading(true);
      };
      window.addEventListener("beforeunload", handleRouteChangeStart);
      return () => {
        window.removeEventListener("beforeunload", handleRouteChangeStart);
      };
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const alphabetArray = t5;
  const [activeTab, setActiveTab] = useState("All");
  const content = {
    All: ["Famotidine", "Farxiga", "Faslodex", "Febuxostat", "Felodipine", "Fenofibrate", "Fentanyl", "FeroSul"],
    Medications: ["Aspirin", "Ibuprofen", "Acetaminophen"],
    Devices: ["Blood Pressure Monitor", "Thermometer", "Glucose Meter"],
    Reps: ["John Doe", "Jane Smith", "Alice Johnson"]
  };
  const [selected] = useState("Ff");
  let t6;
  if ($[6] !== isLoading) {
    t6 = isLoading && <Loader />;
    $[6] = isLoading;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handelBacktoSearch) {
    t7 = () => {
      setIsLoading(true);
      handelBacktoSearch();
    };
    $[8] = handelBacktoSearch;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none"><path d="M19 8.4C19.4971 8.4 19.9 7.99706 19.9 7.5C19.9 7.00294 19.4971 6.6 19 6.6V8.4ZM0.363604 6.8636C0.0121326 7.21508 0.0121326 7.78492 0.363604 8.1364L6.09117 13.864C6.44264 14.2154 7.01249 14.2154 7.36396 13.864C7.71543 13.5125 7.71543 12.9426 7.36396 12.5912L2.27279 7.5L7.36396 2.40883C7.71543 2.05736 7.71543 1.48751 7.36396 1.13604C7.01249 0.784567 6.44264 0.784567 6.09117 1.13604L0.363604 6.8636ZM19 6.6L1 6.6V8.4L19 8.4V6.6Z" fill="#354EF0" /></svg>;
    t9 = <div className="text-[14px] font-normal font-poppins text-[#8E8E8E]">Back to search</div>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7) {
    t10 = <div onClick={t7} className="flex items-center gap-2 cursor-pointer">{t8}{t9}</div>;
    $[12] = t7;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = "flex flex-col  pb-12 pt-6  reps-wrapper ";
  let t12;
  if ($[14] !== selectedAlphabet) {
    t12 = <p className="py-2 mb-4 text-[16px] font-medium text-[#4B4B4B] border-b border-[#E1E1E1] font-poppins">Results for letter :<span className="text-black text-[16px] pl-1 font-semibold font-poppins">{selectedAlphabet}</span></p>;
    $[14] = selectedAlphabet;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== router || $[17] !== selected || $[18] !== selectedAlphabet) {
    t13 = <div className="flex flex-wrap gap-2">{alphabetArray.map(item => <button key={item} onClick={() => {
        setButtonLoading(true);
        setIsLoading(true);
        router.push(`/products/alphabetical/${selectedAlphabet}${item}`);
      }} className={`px-4 text-[20px] font-semibold py-2 rounded-md  ${selected === item ? "bg-[#1E5EFF] text-white" : "bg-[#F5F5F5] text-black"}`}>{selectedAlphabet + item}</button>)}</div>;
    $[16] = router;
    $[17] = selected;
    $[18] = selectedAlphabet;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <div className="p-4  bg-white  rounded-lg">{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = "p-4 flex-1 bg-white mt-6 rounded-lg";
  const t16 = Object.keys(content).map(tab => <button key={tab} className={`px-4 py-2 -mb-px ${activeTab === tab ? "border-b-2 border-[#354EF0] text-[#354EF0]" : "text-[#8E8E8E]"}`} onClick={() => {
    setTabLoading(true);
    setActiveTab(tab);
    setTimeout(() => setTabLoading(false), 300);
  }}>{tab} ({content[tab].length})</button>);
  let t17;
  if ($[23] !== t16) {
    t17 = <div className="flex border-b-2 border-[#E1E1E1]  mb-4">{t16}</div>;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  const t18 = "grid grid-cols-4 gap-4";
  let t19;
  if ($[25] !== router) {
    t19 = item_0 => <div key={item_0} onClick={() => {
      setItemLoading(true);
      setIsLoading(true);
      router.push(`/products/details/${encodeURIComponent(item_0)}`);
    }} className="text-[#354EF0] flex items-center gap-2 text-[16px] font-medium font-inter cursor-pointer hover:underline"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none"><circle cx="5" cy="5.5" r="5" fill="#354EF0" /></svg>{" "}{item_0}</div>;
    $[25] = router;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const t20 = content[activeTab].map(t19);
  let t21;
  if ($[27] !== t20) {
    t21 = <div className={t18}>{t20}</div>;
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t17 || $[30] !== t21) {
    t22 = <div className={t15}>{t17}{t21}</div>;
    $[29] = t17;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t14 || $[33] !== t22) {
    t23 = <div className={t11}>{t14}{t22}</div>;
    $[32] = t14;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t10 || $[36] !== t23 || $[37] !== t6) {
    t24 = <>{t6}{t10}{t23}</>;
    $[35] = t10;
    $[36] = t23;
    $[37] = t6;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  return t24;
};
export default LettersRecomdationPage;